import React from 'react';
import { Hero } from './components/Hero';
import { TrustStrip } from './components/TrustStrip';
import { ProblemsSection } from './components/ProblemsSection';
import { SolutionSection } from './components/SolutionSection';
import { ContentsSection } from './components/ContentsSection';
import { SampleCarousel } from './components/SampleCarousel';
import { BonusesSection } from './components/BonusesSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { ClosingSection } from './components/ClosingSection';
import { SiteFooter } from './components/SiteFooter';
import { StickyOfferBar } from './components/StickyOfferBar';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-white pb-[72px] font-sans text-ink" data-id="element-0" data-mp="28tmdqzjya4vn">
      <main data-id="element-1" data-mp="23w4drynwuzzs">
        <Hero data-id="element-2" data-mp="23ujksdh8vp41" />
        <TrustStrip data-id="element-3" data-mp="23utadzydnu97" />
        <ProblemsSection data-id="element-4" data-mp="23ti8y6semyl9" />
        <SolutionSection data-id="element-5" data-mp="3ik7k0rkruvvx" />
        <ContentsSection data-id="element-6" data-mp="3iiwfuqnezm4a" />
        <SampleCarousel data-id="element-7" data-mp="3ijpd910hgz9r" />
        <BonusesSection data-id="element-8" data-mp="3mlj9mx3nbh44" />
        <OfferSection data-id="element-9" data-mp="3ml17xky7saot" />
        <GuaranteeSection data-id="element-10" data-mp="3mk868ye44bdj" />
        <FaqSection data-id="element-11" data-mp="3mjgannkimdn9" />
        <ClosingSection data-id="element-12" data-mp="3rc9dg5wfbbwp" />
      </main>
      <SiteFooter data-id="element-13" data-mp="3rdas0kcnegj6" />
      <StickyOfferBar data-id="element-14" data-mp="3rcswjpxt86cb" />
    </div>;
}